"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAButtonPressed = exports.unregisterAButtonInput = exports.registerAButtonInput = exports.handleGamepadDisconnect = exports.clearAButtonInputStack = void 0;
const utils_1 = require("../../utils");
const focusManager_1 = require("../focusManager");
// Stack to keep track of input directions and sources.
let inputStack = [];
const clearAButtonInputStack = () => {
    inputStack.length = 0;
};
exports.clearAButtonInputStack = clearAButtonInputStack;
/**
 * Handles the disconnection of a gamepad.
 * Removes all inputs associated with the disconnected gamepad from the input stack.
 * @param gamepadId - The identifier of the disconnected gamepad.
 */
const handleGamepadDisconnect = (gamepadId) => {
    // Filter out all entries with the disconnected gamepadId
    inputStack = inputStack.filter((id) => id !== gamepadId);
    updateCurrentFocus();
};
exports.handleGamepadDisconnect = handleGamepadDisconnect;
/**
 * Registers a input into the input stack.
 * Prevents adding duplicate inputs to the stack.
 * @param gamepadId - The gamepad identifier.
 */
const registerAButtonInput = (gamepadId) => {
    // Check if the same input already exists in the stack
    const alreadyExists = inputStack.some((id) => id === gamepadId);
    if (alreadyExists) {
        return;
    }
    inputStack.push(gamepadId);
    updateCurrentFocus();
};
exports.registerAButtonInput = registerAButtonInput;
/**
 * Unregisters an A button from the input stack.
 * @param gamepadId - The gamepad identifier.
 */
const unregisterAButtonInput = (gamepadId) => {
    // Find and remove the specified input from the stack
    const index = inputStack.findIndex((id) => id === gamepadId);
    if (index > -1) {
        inputStack.splice(index, 1);
    }
    updateCurrentFocus();
};
exports.unregisterAButtonInput = unregisterAButtonInput;
const updateCurrentFocus = () => {
    const currentFocus = (0, focusManager_1.getCurrentlyFocusedInteractable)();
    if (!currentFocus) {
        return;
    }
    (0, utils_1.setGamepadPressed)(currentFocus, (0, exports.isAButtonPressed)());
};
const isAButtonPressed = () => {
    return inputStack.length > 0;
};
exports.isAButtonPressed = isAButtonPressed;
//# sourceMappingURL=data:application/json;base64,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